import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import "./dashboard.css";
import DistributionGraph from "../../Components/DashboardComponents/Analytics/DistributionGraph";
import UserSentiments from "../../Components/DashboardComponents/Analytics/UserSentiments";
import TotalvsAngagementGraph from "../../Components/DashboardComponents/Analytics/TotalvsAngagementGraph";
import QuartileGraph from "../../Components/DashboardComponents/Analytics/QuartileGraph";
import ReactPlayer from "react-player";
import { message } from "antd";
import { ThemeContext } from "../../context/themeProvider";
import userService from "../../services/userService";
import EngagementGraph from "../../Components/DashboardComponents/Analytics/EngagementGraph";
import { BsEye } from "react-icons/bs";
import topArrow from "../../assets/myAnalytics/topArrow.png";
import downArrow from "../../assets/myAnalytics/down-arrow.png";
import ReactSwitch from "react-switch";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

const VideoAnalytics = (props) => {
  const outletProps = useOutletContext();
  const { colorBgContainer } = outletProps;
  const { headerTitle, setHeaderTitle } = props;
  const { setLoading } = useContext(ThemeContext);
  const { id } = useParams();
  const [videoAnalytics, setVideoAnalytics] = useState({});
  const [active, setactive] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [xValues, setXvalues] = useState([]);
  const [yValues, setYvalues] = useState([]);

  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle("Video Engagement Analytics");
    getVideoData(id);
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle("");
    };
  }, [headerTitle]);

  const getVideoData = async (id) => {
    try {
      setLoading(true);

      const response = await userService.getVideoAnalytics(id);

      if (response.error) {
        message.destroy();
        message.error(response?.error?.message || "Something went wrong!");
      } else {
        setVideoAnalytics(response?.data);
        getMapData(response?.data?.heatmap);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setLoading(false);
  };
  console.log("videoAnalytics", videoAnalytics);
  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  // storing x y values for heatmap
  const getMapData = (mapData) => {
    const data = Object.values(mapData);
    const X = data.map((data) => data.x);
    const Y = data.map((data) => data.y);
    setXvalues(X);
    setYvalues(Y);
  };
  // console.log("Xvlues", xValues);
  // console.log("yValues", yValues);

  // heatmapChart
  useLayoutEffect(() => {
    // Create chart instance
    am4core.ready(function () {
      // Use themes
      am4core.useTheme(am4themes_animated);

      // am4core.options.commercialLicense = true;
      // Create chart
      var chart = am4core.create("chartdiv", am4charts.XYChart);
      // Define data
      let XR = xValues;
      let YR = yValues;
      // let XR = [
      //   933, 792, 831, 790, 723, 976, 584, 711, 767, 111, 833, 855, 452, 720,
      //   839, 360, 768, 618, 735, 537, 712, 752, 690, 718, 375, 389, 820, 774,
      //   693, 698, 786, 800, 760, 818, 719, 970, 962, 695, 292, 1124, 885, 750,
      //   230, 778, 734, 751, 777, 746, 836, 842, 875, 815, 876, 791, 980, 560,
      //   1031, 896, 899, 961, 830, 479, -36, 222, 503, 689, 178, 1092, 805, 1004,
      //   487, 1110, 775, 664, 716, 628, -172, 858, 967, 949, -182, -327, 145,
      //   -211, -245, 234, 292, 458, 500, 400, 209, 173, 182, 149, 527, -80, 36,
      //   339, -84, 46, 83, 190, 749, 326, 342, 366, 193, 198, 211, 174, -361,
      //   129, 174, 192, 106, 143, 437, -16, 70, 662, 187, 449, -42, -56, -24,
      //   -45, 15, -71, -223, 594, 276, 196, 1116, 764, 681, 716, 583,
      // ];
      // let YR = [
      //   70, 306, 191, 328, 421, 112, 165, 494, 464, 893, 491, 528, 276, 390,
      //   307, 184, 399, 392, 363, 378, 326, 328, 313, 313, 207, 197, 376, 391,
      //   355, 373, 334, 266, 376, 285, 412, 272, 482, 456, 522, 314, 387, 423,
      //   482, 409, 401, 413, 349, 398, 372, 258, 409, 268, 358, 438, 417, 388,
      //   301, 317, 272, 232, 292, 926, 948, 950, 904, 984, 138, 601, 615, 764,
      //   732, 146, 352, 407, 107, -98, -51, -88, 70, 25, 181, 704, 381, 662, 377,
      //   435, 348, 337, 296, 325, 212, 194, 584, 242, 327, 449, 581, 409, 355,
      //   464, 269, 407, 185, 255, 447, 390, 423, 563, 420, 179, 303, 378, 549,
      //   531, 483, 533, 400, 297, 467, 130, 344, 161, 48, 449, 413, 540, 564,
      //   500, 525, 348, 568, 604, 564, 402, 410, 738, 744,
      // ];
      // let xMax = Number.MIN_VALUE;
      // let yMax = Number.MIN_VALUE;
      // for(let i=0; i<XR.length; i++) {
      //     xMax = Math.max(Math.abs(XR[i]), xMax);
      // }
      // for(let i=0; i<YR.length; i++) {
      //     yMax = Math.max(Math.abs(YR[i]), yMax);
      // }
      // console.log({xMax, yMax});

      // STEP 1:
      for (let i = 0; i < XR.length; i++) {
        XR[i] = (XR[i] / 1366) * 4 - 2;
      }
      for (let i = 0; i < YR.length; i++) {
        YR[i] = (YR[i] / 768) * 4 - 2;
      }
      // STEP 1.1
      for (let i = 0; i < YR.length; i++) {
        YR[i] *= -1;
      }
      let xMax = Number.MIN_VALUE,
        xMin = Number.MAX_VALUE;
      let yMax = Number.MIN_VALUE,
        yMin = Number.MAX_VALUE;
      let maxX;
      let maxY;

      for (let i = 0; i < XR.length; i++) {
        xMax = Math.max(xMax, XR[i]);
        xMin = Math.min(xMin, XR[i]);
      }
      // STEP 2:
      maxX = Math.max(Math.abs(xMax), Math.abs(xMin));
      for (let i = 0; i < YR.length; i++) {
        yMax = Math.max(yMax, YR[i]);
        yMin = Math.min(yMin, YR[i]);
      }
      // STEP 3
      maxY = Math.max(Math.abs(yMax), Math.abs(yMin));
      // for(let i=0; i<YR.length; i++) {
      //     yMax = Math.max(Math.abs(YR[i]), yMax);
      // }
      console.log({
        maxX,
        maxY,
      });
      // STEP 4
      for (let i = 0; i < XR.length; i++) {
        XR[i] = XR[i] + maxX;
        YR[i] = YR[i] + maxY;
      }
      // STEP 5
      let xScale = Number.MIN_VALUE,
        yScale = Number.MIN_VALUE;
      for (let i = 0; i < XR.length; i++) {
        xScale = Math.max(xScale, XR[i]);
        yScale = Math.max(yScale, YR[i]);
      }
      console.log({
        xScale,
        yScale,
      });
      // STEP 6:
      for (let i = 0; i < XR.length; i++) {
        XR[i] = (XR[i] / xScale) * 30;
        YR[i] = (YR[i] / yScale) * 30;
      }
      console.log({
        XR,
        YR,
      });
      // for (let i = 0; i < XR.length; i++) {
      //     if (XR[i] >= 0 && XR[i] <= 10) {
      //         XR[i] = 5;
      //     } else if (XR[i] > 10 && XR[i] <= 20) {
      //         XR[i] = 15;
      //     } else if (XR[i] > 20 && XR[i] <= 30) {
      //         XR[i] = 25;
      //     }
      // }
      // for (let i = 0; i < YR.length; i++) {
      //     if (YR[i] >= 0 && YR[i] <= 10) {
      //         YR[i] = 5;
      //     } else if (YR[i] > 10 && YR[i] <= 20) {
      //         YR[i] = 15;
      //     } else if (YR[i] > 20 && YR[i] <= 30) {
      //         YR[i] = 25;
      //     }
      // }

      // disabling amChart Logo
      // chart.logo.disabled = true;
      // Prepare data
      var data = [];
      for (var i = 0; i < XR.length; i++) {
        data.push({
          x: XR[i],
          y: YR[i],
        });
      }
      chart.data = data;
      // Create axes
      var xAxis = chart.xAxes.push(new am4charts.ValueAxis());
      xAxis.min = 0;
      xAxis.max = 30;
      xAxis.strictMinMax = true;
      xAxis.renderer.grid.template.location = 0;
      var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
      yAxis.min = 0;
      yAxis.max = 30;
      yAxis.strictMinMax = true;
      yAxis.renderer.grid.template.location = 0;
      // Function to create zones
      // function createZone(x1, y1, x2, y2, color) {
      //     var range = chart.plotContainer.createChild(am4core.Rectangle);
      //     range.width = am4core.percent((x2 - x1) / 30 * 100);
      //     range.height = am4core.percent((y2 - y1) / 30 * 100);
      //     range.x = am4core.percent(x1 / 30 * 100);
      //     range.y = am4core.percent((30 - y2) / 30 * 100);
      //     range.fill = am4core.color(color);
      //     range.fillOpacity = 0.3;
      // }
      // Define zones with colors
      // var zones = [
      //     { x1: 0, x2: 10, y1: 0, y2: 10, color: "#FFDDC1", bulletColor: "#FF5733" },
      //     { x1: 10, x2: 20, y1: 0, y2: 10, color: "#FFABAB", bulletColor: "#C70039" },
      //     { x1: 20, x2: 30, y1: 0, y2: 10, color: "#FFC3A0", bulletColor: "#900C3F" },
      //     { x1: 0, x2: 10, y1: 10, y2: 20, color: "#FF677D", bulletColor: "#581845" },
      //     { x1: 10, x2: 20, y1: 10, y2: 20, color: "#D4A5A5", bulletColor: "#DAF7A6" },
      //     { x1: 20, x2: 30, y1: 10, y2: 20, color: "#392F5A", bulletColor: "#FFC300" },
      //     { x1: 0, x2: 10, y1: 20, y2: 30, color: "#31A2AC", bulletColor: "#FF5733" },
      //     { x1: 10, x2: 20, y1: 20, y2: 30, color: "#61C0BF", bulletColor: "#C70039" },
      //     { x1: 20, x2: 30, y1: 20, y2: 30, color: "#6B4226", bulletColor: "#900C3F" }
      // ];
      // Create zones
      var zones = [
        {
          x1: 0,
          x2: 10,
          y1: 0,
          y2: 10,
        },
        {
          x1: 10,
          x2: 20,
          y1: 0,
          y2: 10,
        },
        {
          x1: 20,
          x2: 30,
          y1: 0,
          y2: 10,
        },
        {
          x1: 0,
          x2: 10,
          y1: 10,
          y2: 20,
        },
        {
          x1: 10,
          x2: 20,
          y1: 10,
          y2: 20,
        },
        {
          x1: 20,
          x2: 30,
          y1: 10,
          y2: 20,
        },
        {
          x1: 0,
          x2: 10,
          y1: 20,
          y2: 30,
        },
        {
          x1: 10,
          x2: 20,
          y1: 20,
          y2: 30,
        },
        {
          x1: 20,
          x2: 30,
          y1: 20,
          y2: 30,
        },
      ];
      // Count occurrences in each zone
      var zoneCounts = zones.map((zone) => {
        var count = 0;
        for (var i = 0; i < XR.length; i++) {
          if (
            XR[i] >= zone.x1 &&
            XR[i] < zone.x2 &&
            YR[i] >= zone.y1 &&
            YR[i] < zone.y2
          ) {
            count++;
          }
        }
        return count;
      });
      console.log("zoneCOunt", zoneCounts);

      const zoneColor = [
        "#EAF458",
        "#F4EA58",
        "#F4D558",
        "#F4C058",
        "#F4AB58",
        "#F49758",
        "#F48258",
        "#F46D58",
        "#F45858",
      ];

      // Find max occurrence
      var maxCount = Math.max(...zoneCounts);
      console.log("maxCOunt", maxCount);
      zoneCounts.map((count, index) => {
        let red = Math.round((count / maxCount) * 8);
        zones[index] = {
          ...zones[index],
          color: zoneColor[red],
        };
      });
      console.log(zones);
      // Function to create zones
      function createZone(x1, y1, x2, y2, color) {
        var range = chart.plotContainer.createChild(am4core.Rectangle);
        range.width = am4core.percent(((x2 - x1) / 30) * 100);
        range.height = am4core.percent(((y2 - y1) / 30) * 100);
        range.x = am4core.percent((x1 / 30) * 100);
        range.y = am4core.percent(((30 - y2) / 30) * 100);
        range.fill = am4core.color(color);
        range.fillOpacity = 0.5;
      }
      // Create chart
      chart.data = XR.map((x, i) => ({
        x,
        y: YR[i],
      }));
      // Create the zones on the chart
      // zones.forEach((zone, index) => {
      //     var range = chart.plotContainer.createChild(am4core.Rectangle);
      //     range.width = am4core.percent((zone.x2 - zone.x1) / 30 * 100);
      //     range.height = am4core.percent((zone.y2 - zone.y1) / 30 * 100);
      //     range.x = am4core.percent(zone.x1 / 30 * 100);
      //     range.y = am4core.percent((30 - zone.y2) / 30 * 100);
      //     range.fill = am4core.color(zone.color);
      //     range.fillOpacity = 0.3;
      //     // Set the bullet size based on the count with a maximum radius limit
      //     data.forEach(point => {
      //         if (point.x >= zone.x1 && point.x < zone.x2 && point.y >= zone.y1 && point
      //             .y < zone.y2) {
      //             var count = zoneCounts[index];
      //             var maxRadius = Math.min((zone.x2 - zone.x1), (zone.y2 - zone.y1)) / 2;
      //             point.size = Math.min(count * 3,
      //                 maxRadius); // Adjust the multiplier as needed for visibility
      //             point.color = zone.bulletColor;
      //         }
      //     });
      // });
      // Create series
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueX = "x";
      series.dataFields.valueY = "y";
      series.strokeOpacity = 0; // Hide the line
      // Add circle bullets
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.propertyFields.radius = "size"; // Set the size dynamically
      bullet.circle.propertyFields.fill = "color"; // Set the color dynamically
      bullet.circle.stroke = am4core.color("#ffffff");
      bullet.circle.strokeWidth = 2;
      // Create the zones
      zones.forEach(function (zone) {
        createZone(zone.x1, zone.y1, zone.x2, zone.y2, zone.color);
      });
      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      // dispose the
      return () => {
        chart.dispose();
      };
    });
  }, [xValues, yValues]);

  return (
    <section
      style={{ background: colorBgContainer }}
      className="my-analytics-container"
    >
      <div className="row">
        <Link to="/dashboard/myAnalytics" className="text-decoration-none">
          <div className="anaylytics-title">
            <span>
              {" "}
              <IoIosArrowBack color="black" />
            </span>
            <h4>
              {videoAnalytics?.video
                ? videoAnalytics?.video?.name?.slice(0, 50) + "..."
                : ""}
            </h4>
          </div>
        </Link>
        <div className="col-lg-9 ">
          <div
            className="bg-dark rounded mb-0 pb-0"
            style={{ position: "relative" }}
          >
            {/* heatmap toggle button */}
            <div className=" text-end pe-2">
              <div style={{ position: "relative", zIndex: 1 }} className="col">
                <span
                  style={{
                    color: "white",
                    fontSize: "16px",
                    marginRight: "10px",
                  }}
                >
                  Heatmap Display
                </span>

                <ReactSwitch
                  checked={isChecked}
                  onChange={handleToggle}
                  uncheckedIcon={
                    <p
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        paddingTop: "2px",
                        color: "white",
                      }}
                    >
                      OFF
                    </p>
                  }
                  checkedIcon={
                    <p
                      style={{
                        fontSize: "11px",
                        fontWeight: "800",
                        paddingTop: "2px",
                        paddingLeft: "1px",
                        color: "white",
                      }}
                    >
                      ON
                    </p>
                  }
                  height={20}
                  width={45}
                  onColor="#1974CE"
                  offColor="#E41A17"
                />
              </div>
            </div>
            {/* heatmap graph */}

            {/* video player */}
            <div className="video-responsive">
              <div
                style={{
                  display: `${isChecked ? "block" : "none"}`,
                  position: "absolute",
                  background: "rgba(0,0,0,0.8)",
                  paddingRight: "5%",
                  paddingTop: "1.5%",
                  right: 0,
                  left: 0,
                  cursor: "pointer",
                  zIndex: 5,
                  height: "100%",
                  width: "100%",
                }}
              >
                <div
                  id="chartdiv"
                  style={{ height: "100%", width: "100%" }}
                ></div>
              </div>

              <ReactPlayer
                id="youtube-video-player"
                url={videoAnalytics?.video?.videoId}
                controls={true}
              />
              {/* video engagement graph */}
              <div
                style={{
                  position: "absolute",
                  bottom: active ? "172px" : "43px",
                  background: "rgba(0,0,0,0.8)",
                  padding: "1%",
                  right: "0%",
                  borderRadius: "5px 0 0 0",
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  zIndex: 2,
                }}
                onClick={() => setactive(!active)}
              >
                <img src="https://img.icons8.com/material-outlined/24/ffffff/combo-chart.png" />
                {active ? (
                  <img
                    src={downArrow}
                    alt=""
                    style={{ width: "22px", paddingRight: "1%" }}
                  />
                ) : (
                  <img
                    src={topArrow}
                    alt=""
                    style={{ width: "22px", paddingRight: "1%" }}
                  />
                )}
                &nbsp;
                <div
                  style={{
                    color: "white",
                    border: "1px solid white",
                    borderRadius: "5px",
                    padding: "0px 2px 0px 2px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                  title="Total User Count"
                >
                  <BsEye fontSize="18px" />
                  {videoAnalytics?.videoPlayCount
                    ? videoAnalytics?.videoPlayCount
                    : 0}
                </div>
              </div>
              {active && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "43px",
                    background: "rgba(0,0,0,0.8)",
                    padding: "0%",
                    width: "100%",
                    margin: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <EngagementGraph
                    engagement={videoAnalytics?.engagementForGraph}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-3 flex-in-sm-laptop">
          <div className="engagement-attension-card engagement-attension-card-margin  col-md-6 col-lg-12">
            <h5>Engagement and Attention Span</h5>
            <div className="">
              <p>Average Attention Span</p>

              <h4>
                {videoAnalytics?.overAllEngagement} <span>%</span>
              </h4>
            </div>
            <div
              style={{ borderBottom: "1px solid #CACACE", marginTop: ".7rem" }}
            ></div>
            <div>
              <p>Average Engagement Span</p>

              <h4>
                {videoAnalytics?.attensionSpan} <span>%</span>
              </h4>
            </div>
          </div>

          <div className="engagement-attension-card  mt-4 col-md-6 col-lg-12">
            <h5>Engagement Distribution</h5>

            <div className="d-flex justify-content-center">
              <DistributionGraph
                engagementDistribution={videoAnalytics?.engagementDistribution}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-2 col-md-4">
          <UserSentiments emotions={videoAnalytics?.emotions} />
        </div>
        <div className="col-lg-5 col-md-8">
          <TotalvsAngagementGraph videoAnalytics={videoAnalytics} />
        </div>
        <div className="col-lg-5 col-md-12">
          <QuartileGraph
            quartileEngagement={videoAnalytics?.quartileEngagement}
          />
        </div>
      </div>
    </section>
  );
};

export default VideoAnalytics;
